import paxios from "@/common/paxios";

import { AD_LAYOUT_STUBS, AD_PLACEMENTS } from "@/common/consts";
import {
	getDataFormattedUTCDate,
	getRandomItemsFromArray,
} from "@/common/functions";

import Advertising from "@/components/advertising";
import Breadcrumb from "@/components/breadcrumb";
import NotFoundContent from "@/pages/page-not-found/content.vue";
import Sidebar from "@/components/template-components/sidebar";
import metaInfo from "./meta";
import methods from "./methods";
import ArticleListEntry from "../ArticleListEntry";
import LatestArticles from "../LatestArticles";
import RelatedLinks from "@/components/related-links";
import SocialSharing from "@/components/social-sharing";
import { mapGetters } from "vuex";

export default {
	name: "PagesArticleDetail",
	components: {
		Advertising,
		ArticleListEntry,
		Breadcrumb,
		LatestArticles,
		NotFoundContent,
		Sidebar,
		RelatedLinks,
		SocialSharing,
	},
	metaInfo,
	methods,
	data() {
		return {
			AD_LAYOUT_STUBS,
			AD_PLACEMENTS,
			isLoading: false,
			isError: false,
			article: {},
			articles: [],
			breadcrumbs: [
				{
					label: this.$t("BreadcrumbArticlesIndex"),
					url: "/blog/",
					clickable: true,
				},
			],
		};
	},
	computed: {
		...mapGetters("device", [
			"isSmallDevice",
			"isMediumDeviceOrWider",
			"isMediumLandscapeDeviceOrWider",
		]),
		latestArticles() {
			if (!this.article.id) return [];

			const currentId = this.article.id;
			return this.articles.filter((a) => a.id !== currentId).slice(0, 3);
		},
		isHideDate() {
			return !!this.article?.flags?.includes?.("hide-date");
		},
		entryDate() {
			return this.article.updatedAt
				? new Date(this.article.updatedAt).toLocaleDateString("en", {
						month: "short",
						day: "numeric",
						year: "numeric",
				  })
				: null;
		},
		entryMeta() {
			const strings = [];
			if (this.article.author.displayName) {
				strings.push(this.article.author.displayName);
			}

			if (!this.isHideDate && this.entryDate) {
				strings.push(this.entryDate);
			}

			strings.push(
				`${this.article.minutesToRead} ${this.$t(
					"ArticlesIndexPageReadingTime"
				)}`
			);

			return strings.join(" &bull; ");
		},
		entryTags() {
			if (this.article && this.article.tags && this.article.tags.length) {
				return this.article.tags;
			}

			return [];
		},
		entryPublishedTime() {
			const firstPublishedAt = this.article.firstPublishedAt;

			return firstPublishedAt
				? new Date(firstPublishedAt).toLocaleDateString("en-CA")
				: null;
		},
		showAds() {
			return !this.$store.state.hideArticleAds;
		},
	},
	async created() {
		await this.getArticleData(this.$route.params.slug);

		paxios
			.get(
				"https://api.yourdictionary.com/cms/v1/wfa/category/.web/articles?orderBy=-publishedAt"
			)
			.then((response) => {
				if (response.status === 200 && response.data.status === 200) {
					let articles = response.data.data.filter(
						(entry) => entry.id !== this.article.id
					);

					this.articles = getRandomItemsFromArray(articles, 3).sort(
						(a, b) => b.publishedAt - a.publishedAt
					);
				}
			});
	},
	watch: {
		"$route.params.slug": "getArticleData",
	},
	destroyed() {
		this.$store.commit("setHideArticleAds", false);
	},
};
